export default "<app-filebox [fileLimit]=\"5\" (fileEndPoint)=\"handleCapture($event)\"></app-filebox>\n"